import { LazyComponentLoader } from './shared/lazy-component';

/*
 * Components loaded with import() instead of being part of main.js — see
 * shared/lazy-component.ts. Each module file re-exports its component, so
 * one import() fetches one chunk. Their modules must not be imported by an
 * eagerly loaded module (AppModule, NewHeaderModule …), or the code goes
 * back into main.js. Lazy route modules can still import them normally
 * (new-menu, shop, new-checkout … use app-new-side-cart in their templates).
 */

/** Item options modal (AppComponent; opened through RecipeOptionModalService). */
export const loadRecipeOptionModal: LazyComponentLoader = () =>
  import('./recipe-option-modal/recipe-option-modal.module').then((m) => ({
    module: m.RecipeOptionModalModule,
    component: m.RecipeOptionModalComponent,
  }));

/** "Would you like to add…" popup (AppComponent; opened through RecomendationsSwitchService). */
export const loadNewRecomendations: LazyComponentLoader = () =>
  import('./new-recomendations/new-recomendations.module').then((m) => ({
    module: m.NewRecomendationsModule,
    component: m.NewRecomendationsComponent,
  }));

/** Cart in the header's cart drawer (NewHeaderComponent). */
export const loadNewSideCart: LazyComponentLoader = () =>
  import('./new-side-cart/new-side-cart.module').then((m) => ({
    module: m.NewSideCartModule,
    component: m.NewSideCartComponent,
  }));

/** AI chat widget, only for brands with TemplateData.RetailAI enabled (AppComponent). */
export const loadRetailAiWidget: LazyComponentLoader = () =>
  import('./retail-ai/retail-ai-widget.module').then((m) => ({
    module: m.RetailAiWidgetModule,
    component: m.RetailAiWidgetComponent,
  }));
